module.exports = __webpack_public_path__ + "img/coming-soon-dark.7c3b54b9.svg";